<template lang="pug">
  .agv-ri-delivery
    div(v-if='renter.is_delivery_offered')
      template(v-if="isLoggedIn")
        //- Car
        div.delivery-info(v-if='renter.uses_cars')
          span.price.price-with-discount(v-if="hasDiscount('car')")
            | {{discounted('car') | money(renter.country)}}
          span.price(v-else)
            | {{original('car') | money(renter.country)}}
          |  — легковая
          .for-individuals(v-if="hasDiscount('car')")
            | {{original('car') | money(renter.country)}} {{discountTypeText}}
        //- Van
        div.delivery-info(v-if='renter.uses_vans')
          span.price.price-with-discount(v-if="hasDiscount('van')")
            | {{discounted('van') | money(renter.country)}}
          span.price(v-else)
            | {{original('van') | money(renter.country)}}
          |  — грузовая
          .for-individuals(v-if="hasDiscount('van')")
            | {{original('van') | money(renter.country)}} {{discountTypeText}}
        //- Truck (fallback when vans disabled but trucks enabled)
        div.delivery-info(v-if='renter.uses_trucks && !renter.uses_vans')
          span.price.price-with-discount(v-if="hasDiscount('truck')")
            | {{discounted('truck') | money(renter.country)}}
          span.price(v-else)
            | {{original('truck') | money(renter.country)}}
          span.currency
            | {{renter.country | currencySymbol}}
          .for-individuals(v-if="hasDiscount('truck')")
            | {{original('truck') | money(renter.country)}} {{discountTypeText}}
          |  — грузовая
      template(v-else)
        //- Car
        div(v-if='renter.uses_cars')
          span.price
            | {{original('car') | money(renter.country)}}
          |  — легковая
        //- Van
        div(v-if='renter.uses_vans')
          span.price
            | {{original('van') | money(renter.country)}}
          |  — грузовая
        //- Truck (fallback when vans disabled but trucks enabled)
        div(v-if='renter.uses_trucks && !renter.uses_vans')
          span.price
            | {{original('truck') | money(renter.country)}}
          span.currency
            | {{renter.country | currencySymbol}}
          |  — грузовая
    div(v-else)
      | Не предоставляется
</template>

<script>
  import eventBus from 'Shared/eventBus'

  export default {
    name: 'agv-ri-delivery',
    props: {
      renter: Object,
      deliveryDiscountInfo: Object,
    },
    computed: {
      isLoggedIn() {
        return !!_.get(this.$store.state.customer.current, 'id')
      },
      showDiscountType() {
        return this.deliveryDiscountInfo && 
               (this.deliveryDiscountInfo.is_customer_special_discount || 
                this.deliveryDiscountInfo.renter_service_discount > 0);
      },
      discountTypeText() {
        return 'для частников';
      }
    },
    methods: {
      original(type) {
        if (!this.deliveryDiscountInfo) {
          switch(type) {
            case 'car': return this.renter.intratown_car_delivery_price
            case 'van': return this.renter.intratown_van_delivery_price
            case 'truck': return this.renter.intratown_truck_delivery_price
          }
        } else {
          switch(type) {
            case 'car': return this.deliveryDiscountInfo.intratown_car_delivery_price
            case 'van': return this.deliveryDiscountInfo.intratown_van_delivery_price
            case 'truck': return this.deliveryDiscountInfo.intratown_truck_delivery_price
          }
        }
      },
      discounted(type) {
        if (!this.deliveryDiscountInfo) {
          // Fallback to renter object if deliveryDiscountInfo is not provided
          switch(type) {
            case 'car': return this.renter.intratown_car_delivery_price_with_discount
            case 'van': return this.renter.intratown_van_delivery_price_with_discount
            case 'truck': return this.renter.intratown_truck_delivery_price_with_discount
          }
        } else {
          switch(type) {
            case 'car': return this.deliveryDiscountInfo.intratown_car_delivery_price_with_discount
            case 'van': return this.deliveryDiscountInfo.intratown_van_delivery_price_with_discount
            case 'truck': return this.deliveryDiscountInfo.intratown_truck_delivery_price_with_discount
          }
        }
      },
      hasDiscount(type) {
        const d = this.discounted(type)
        const o = this.original(type)
        return d && o && d < o
      }
    }
  }
</script>

<style scoped>
  .delivery-info {
    margin-bottom: 10px;
  }

  .price {
    font-size: 14px;
    color: #000000;
  }

  .currency {
    font-size: 16px;
    margin-left: 3px;
  }

  .price.price-with-discount {
    color: #2ea50d;
    font-weight: 600;
  }

  .for-individuals {
    font-size: 12px;
    font-weight: 400;
    margin-top: 2px;
    margin-bottom: 5px;
    color: #828282;
  }

</style>
